import { render } from "./InvitationProfilesListViewButtons.vue?vue&type=template&id=103cabfa&ts=true"
import script from "./InvitationProfilesListViewButtons.vue?vue&type=script&lang=ts"
export * from "./InvitationProfilesListViewButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__